var generateStyle = function generateStyle(componentTheme) {
  return {
    question: {
      width: '100%',
      padding: "".concat(componentTheme.questionPaddingTop, " ").concat(componentTheme.questionPaddingSide, " ").concat(componentTheme.questionPaddingBottom),
      boxSizing: 'border-box',
      cursor: 'pointer'
    },
    headerSection: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    questionPosition: {
      flex: '1 1 0',
      alignItems: 'center',
      fontSize: '1.4rem',
      color: componentTheme.questionPositionColor
    },
    points: {
      display: 'flex',
      flex: '2 2 auto',
      justifyContent: 'flex-end',
      alignItems: 'center',
      paddingRight: '5px'
    }
  };
};
export default generateStyle;